import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import React from "react";
import {color, radius, type} from "common/tokens";

const useStyles = makeStyles({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    borderRadius: radius.PILL,
    border: '1px solid transparent',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  // Deadline chips on session cards.
  due: {
    ...type.chip,
    padding: '6px 12px',
    background: color.CHIP_BG,
    borderColor: color.CHIP_BORDER,
    color: color.CHIP_TEXT,
  },
  dueOverdue: {
    color: color.CHIP_OVERDUE_TEXT,
  },
  // Mentor / mentee labels on the group roster.
  role: {
    ...type.chipSmall,
    padding: '4px 8px',
    background: color.ROLE_CHIP_BG,
    color: color.ROLE_CHIP_TEXT,
  },
  // Progress state on a session card's image.
  status: {
    ...type.chipSmall,
    padding: '4px 8px',
    background: color.ACCENT,
    color: color.ON_ACCENT,
  },
  statusDone: {
    background: color.SUCCESS,
    color: color.AVATAR_DONE_TEXT,
  },
  small: {
    ...type.chipSmall,
    letterSpacing: 'normal',
    textTransform: 'none',
    padding: '3px 8px',
  },
  // Unread counts and other numeric badges.
  count: {
    ...type.label,
    padding: '0 6px',
    minWidth: 19,
    justifyContent: 'center',
    background: color.PURPLE_TINT,
    color: color.PURPLE,
  },
});

const Chip = ({
  variant = 'due',
  overdue = false,
  done = false,
  size,
  icon,
  children,
  className,
}) => {
  const classes = useStyles();

  return (
    <span
      className={classNames(
        classes.chip,
        classes[variant],
        variant === 'due' && overdue && classes.dueOverdue,
        variant === 'status' && done && classes.statusDone,
        size === 'small' && classes.small,
        className
      )}
    >
      {icon}
      {children}
    </span>
  );
};

export default Chip;
